import { Property, PropertyAddress } from './property';

// Helper function to check if address is PropertyAddress object
export const isPropertyAddress = (address: string | PropertyAddress | undefined): address is PropertyAddress => {
  return typeof address === 'object' && address !== null && 'street' in address;
};

// Helper function to get address string
export const getAddressString = (property: Property): string => {
  if (!property.address) return '';

  if (isPropertyAddress(property.address)) {
    return `${property.address.street}, ${property.address.city}, ${property.address.state} ${property.address.zip}`;
  }

  return property.address;
};

// Helper function to get city from property
export const getCity = (property: Property): string => {
  if (property.city) return property.city;
  if (isPropertyAddress(property.address)) return property.address.city;
  return '';
};

// Helper function to get state from property
export const getState = (property: Property): string => {
  if (property.state) return property.state;
  if (isPropertyAddress(property.address)) return property.address.state;
  return '';
};

// Helper to safely format price
export const safeFormatPrice = (price: number | undefined): string => {
  if (!price) return '$0';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(price);
};

// Helper to get property identifier (mlsNumber or id)
export const getPropertyId = (property: Property): string => {
  return property.mlsNumber || property.id?.toString() || '';
};
